<div class="">
  <div class="relative">
    <img src="assets/help-hero.webp" class="mobile-m:h-[530px] h-[350px] w-full object-cover brightness-[.55] contrast-125">
    <div class="absolute inset-0 flex items-center justify-center">
      <h1 class="text-[var(--white)] mobile-m:text-[73px]/[73px] text-[60px]/[60px] uppercase">{{ 'help.title' | translate }}</h1>
    </div>
  </div>

  <div class="mx-auto container-padding max-w-screen-desktop">
    <div class="p-16 w-full grid mobile-m:grid-cols-2 grid-cols-1 rounded-xl bg-[var(--white)] border border-[4px] border-[var(--black)] my-16 gap-8">
      <div class="col-span-1">
        <h2 class="font-normal mobile-m:text-[60px]/[60px] text-[45px]/[45px] uppercase">{{ 'help.howCanWeHelp' | translate }}</h2>
      </div>

      <div class="col-span-1 flex flex-col gap-4">
        <h3 class="uppercase text-[var(--dark-orange)] mobile-m:text-[45px]/[45px] text-[30px]/[30px]">{{ 'help.contactLines' | translate }}</h3>
        <p class="flex gap-2 items-center uppercase font-bold mobile-m:text-[18px]/[18px] text-[13px]/[13px]">
          <fa-icon [icon]="faMail" size="xl"></fa-icon>
          <a href="mailto:soporte&#64;drinkhopping.com" class="hover:underline">soporte&#64;drinkhopping.com</a>
        </p>
        <div class="flex gap-3 items-center">
          <p class="uppercase font-bold mobile-m:text-[18px]/[18px] text-[13px]/[13px]">{{ 'help.social' | translate }}</p>
          <a href="https://www.instagram.com/drink.hopping" target="_blank" rel="noopener noreferrer" class="text-[var(--black)] hover:text-[var(--secondary)]" aria-label="Instagram">
            <fa-icon style="color: var(--dark-orange);" [icon]="faInstagram" size="xl"></fa-icon>
          </a>
          <a href="https://www.tiktok.com/@drink.hopping" target="_blank" rel="noopener noreferrer" class="text-[var(--black)] hover:text-[var(--secondary)]" aria-label="TikTok">
            <fa-icon style="color: var(--dark-orange);" [icon]="faTiktok" size="xl"></fa-icon>
          </a>
          <a href="https://www.facebook.com/drink.hopping" target="_blank" rel="noopener noreferrer" class="text-[var(--black)] hover:text-[var(--secondary)]" aria-label="Facebook">
            <fa-icon style="color: var(--dark-orange);" [icon]="faFacebook" size="xl"></fa-icon>
          </a>
        </div>
      </div>
    </div>

    <div class="pb-16">
      <h3 class="text-[var(--dark-orange)] mobile-m:text-[45px]/[45px] text-[30px]/[30px] uppercase mb-6">{{ 'help.faq' | translate }}</h3>
      <div *ngFor="let question of questions" class="mb-4">
        <h4 class="bg-[var(--grey)] mb-2 p-4 rounded-xl mobile-m:text-[18px]/[18px] text-[15px]/[15px] uppercase font-semibold flex justify-between items-center cursor-pointer" (click)="toggleQuestion(question)">
          {{ question.question }}
          <fa-icon *ngIf="!question.isExpanded" style="color: var(--tertiary);" [icon]="faChevronDown" size="lg"></fa-icon>
          <fa-icon *ngIf="question.isExpanded" style="color: var(--tertiary);" [icon]="faChevronUp" size="lg"></fa-icon>
        </h4>
        <p class="text-[14px]/[14px] mt-2 p-4 font-normal" [style.white-space]="'pre-line'" *ngIf="question.isExpanded">{{ question.answer }}</p>
      </div>
    </div>
  </div>
</div>
